module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_6.7c4ded22.jpg";